if (process.env.NODE_ENV !== 'development'){
  console.log = function() {};
}

const RESIZE_OBSERVER_BENIGN = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener('error', (e) => {
  if (e.message && RESIZE_OBSERVER_BENIGN.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason && (e.reason.message || String(e.reason));
  if (msg && RESIZE_OBSERVER_BENIGN.test(msg)) {
    e.preventDefault();
  }
});

import { createApp } from 'vue';
import App from './App.vue';
import { createVuetify } from 'vuetify';
import router from './router'

import 'vuetify/styles'; // Ensure you import Vuetify styles
import '@mdi/font/css/materialdesignicons.css'; // Optional for icons

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import './assets/css/design-tokens.css'   // CSS custom properties (single source of truth)
import './assets/css/duallo-components.css' // shared, opt-in component classes built on the tokens
import './assets/css/main-styles.css'
import { auth } from './utils/Authorization';
import { createPinia } from 'pinia';

const dualloCoreTheme = {
  dark: false,
  colors: {
    background: '#25333a',
    surface: '#25333a',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#424242',
    'on-surface-variant': '#EEEEEE',
    primary: '#1867C0',
    'primary-darken-1': '#1F5592',
    secondary: '#48A9A6',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
  variables: {
    'border-color': '#000000',
    'border-opacity': 0.12,
    'high-emphasis-opacity': 0.87,
    'medium-emphasis-opacity': 0.60,
    'disabled-opacity': 0.38,
    'idle-opacity': 0.04,
    'hover-opacity': 0.04,
    'focus-opacity': 0.12,
    'selected-opacity': 0.08,
    'activated-opacity': 0.12,
    'pressed-opacity': 0.12,
    'dragged-opacity': 0.08,
    'theme-kbd': '#212529',
    'theme-on-kbd': '#FFFFFF',
    'theme-code': '#F5F5F5',
    'theme-on-code': '#000000',
    'font-family': 'Inter, sans-serif',
  }
}

const vuetify = createVuetify({  
  components,
  directives,
  theme: {
    defaultTheme: 'dualloCoreTheme',
    themes: {
      dualloCoreTheme
    }
  },
});

const pinia = createPinia();

createApp(App)
  .use(pinia)
  .use(router)
  .use(vuetify)
  .use(auth)
  .mount('#app');
